import { DestroyRef, Injectable, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';

@Injectable({
    providedIn: 'root',
})
export class NavigateBackService {
    private readonly history: string[] = [];
    private readonly router = inject(Router);
    private readonly destroyRef = inject(DestroyRef);

    public parentUri?: string;

    public constructor() {
        this.router.events.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.history.push(event.urlAfterRedirects);
            }
        });
    }

    public async goBackOrToParentPage(): Promise<void> {
        this.history.pop();
        const url = this.history.length > 0 ? this.history[this.history.length - 1] : this.parentUri;
        await this.router.navigateByUrl(url ?? '/');
    }
}
